import { render, staticRenderFns } from "./cdk-record.vue?vue&type=template&id=a66fdd62&"
import script from "./cdk-record.vue?vue&type=script&lang=js&"
export * from "./cdk-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports